import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgUndoDot = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	stroke: "currentColor",
	strokeWidth: 2,
	strokeLinecap: "round",
	strokeLinejoin: "round",
	className: "lucide lucide-undo-dot-icon lucide-undo-dot",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", { d: "M21 17a9 9 0 0 0-15-6.7L3 13" }),
		/* @__PURE__ */ _jsx("path", { d: "M3 7v6h6" }),
		/* @__PURE__ */ _jsx("circle", {
			cx: 12,
			cy: 17,
			r: 1
		})
	]
});
export default SvgUndoDot;
